/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReadDummiesByUserResponse } from '../../models/read-dummies-by-user-response';

export interface GetReadDummiesByUser$Params {
}

export function getReadDummiesByUser(http: HttpClient, rootUrl: string, params?: GetReadDummiesByUser$Params, context?: HttpContext): Observable<StrictHttpResponse<ReadDummiesByUserResponse>> {
  const rb = new RequestBuilder(rootUrl, getReadDummiesByUser.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReadDummiesByUserResponse>;
    })
  );
}

getReadDummiesByUser.PATH = '/api/dummies/read-by-user';
